function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProducts = function SvgProducts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prefix__Group_157",
    width: 24,
    height: 24,
    "data-name": "Group 157",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_11",
    d: "M0 0h24v24H0z",
    "data-name": "Path 11",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_12",
    d: "M3.6 3h12.8L18 6.2v10.4a.8.8 0 0 1-.8.8H2.8a.8.8 0 0 1-.8-.8V6.2zm12.8 4.8H3.6v8h12.8zm-.189-1.6l-.8-1.6H4.59l-.8 1.6z",
    "data-name": "Path 12",
    transform: "translate(2 2)",
    style: {
      fill: "#32325d"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProducts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/products.4d33fb6f.svg";
export { ForwardRef as ReactComponent };